import React from 'react';
import Header from './header';

import { URL } from '../variables';
import { connect } from 'react-redux';
import { mudarUser, logout } from '../actions/AppActions';
import { Redirect, Link } from 'react-router-dom';
import Loader from '../components/Loader';

import moment from 'moment-timezone';

class ListaCandidatos extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            msg: '',
            loading_screen: false,
            show_video: false,
            show_solicitar: true,
            show_aceitar: false,
            stream: null,
            redirect: false,
            path: '/sala',
            candidatos: [],
            candidatos_nao_finalizados: [],

        }

        // this.videoRef=null;
    }
    componentDidMount() {
        this.get_candidatos();

    }

    componentWillUnmount() {
    }

    async get_candidatos() {
        this.setState({ loading_screen: true });
        fetch(`${URL}api/corretor/get_candidatos/${this.props.sala_id}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);

                    // this.props.mudarLoadingHome(false);

                }
                else {
                    this.setState({ loading_screen: false, candidatos: resp.candidatos,candidatos_nao_finalizados:resp.candidatos_nao_finalizados });

                }




            } catch (err) {
                console.log(err);
                // this.props.mudarLoadingHome(false);


            }

        })
            .catch((err) => {
                console.log(err);
                // this.props.mudarLoadingHome(false);

            });
    }







    render() {
        return (
            <div className="row correcao-list-panel">
                {this.state.redirect == true && <Redirect to={this.state.path} />}


                <div className="col-12">
                <br />

                    <div className="correcao-section-heading">
                        <span>Sala de correção</span>
                        <h4 className="mt-0 header-title">Sala {this.props.sala_numero}</h4>
                        <p>Candidatos vinculados a esta sala e status de finalização da correção.</p>
                    </div>

                    {/* <hr /> */}
                    {this.state.loading_screen == false && <div>

                        <div className="correcao-card-list">
                            {this.state.candidatos.map((item, id) => {
                                let pending = this.state.candidatos_nao_finalizados.includes(item);
                                return (
                                    <Link key={id} to={'/redacoes/' + item.id} className="correcao-list-card">
                                        <div className={pending ? 'correcao-list-icon correcao-list-icon-orange' : 'correcao-list-icon'}>
                                            <i className={pending ? 'mdi mdi-alert-circle-outline' : 'mdi mdi-check-circle-outline'}></i>
                                        </div>
                                        <div className="correcao-list-main">
                                            <span>Identificação</span>
                                            <strong>#{item}</strong>
                                            <p>{pending ? 'Correção ainda não finalizada' : 'Correção finalizada'}</p>
                                        </div>
                                        <div className={pending ? 'correcao-status-pill pending' : 'correcao-status-pill done'}>
                                            {pending ? 'Pendente' : 'Finalizada'}
                                        </div>
                                        <div className="correcao-list-action">
                                            <span>Abrir</span>
                                            <i className="mdi mdi-arrow-right"></i>
                                        </div>
                                    </Link>
                                )
                            })}
                        </div>
                        {this.state.candidatos.length == 0 && <div className="correcao-process-empty">
                            <i className="mdi mdi-account-alert-outline"></i>
                            <p>Nenhum candidato nesta sala</p>
                        </div>}
                    </div>}

                    {this.state.loading_screen == true && <Loader />}



                </div>

            </div>


        );
    }


}

const mapsStateToProps = (state) => (
    {
        token: state.AppReducer.token,
        faculdade: state.AppReducer.faculdade,
        processo: state.AppReducer.processo,
        user: state.AppReducer.user,
    }
);

export default connect(mapsStateToProps, { mudarUser, logout })(ListaCandidatos);
